import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "time-recoder" }
const _hoisted_2 = { class: "text-2xl font-bold" }
const _hoisted_3 = { class: "time-recoder__table mt-4" }
const _hoisted_4 = { class: "heading-table mb-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Table = _resolveComponent("Table")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('timeClockSettings')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('settingTimeRecoder.timeClockType')), 1),
      _hoisted_5,
      _createVNode(_component_Table, {
        headers: _ctx.timeRecoderHeader,
        data: _ctx.unitList,
        showPagination: true,
        recordTotal: _ctx.pagination.total,
        itemsPerPages: _ctx.pagination.per_page,
        currentPage: _ctx.paramListUnit.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.paramListUnit.page = $event)),
        onOnChangePage: _ctx.onChangePage,
        class: "w-fit text-sm text-center"
      }, {
        edit: _withCtx(({ item }) => [
          _withDirectives(_createVNode("div", {
            class: "text-center",
            onClick: ($event: any) => (_ctx.redirectTimeRecoderDetail(item))
          }, [
            _createVNode(_component_BaseIcon, {
              name: "pencil-line",
              class: "cursor-pointer"
            })
          ], 8, ["onClick"]), [
            [_directive_tooltip, _ctx.t('actionEdit')]
          ])
        ]),
        _: 1
      }, 8, ["headers", "data", "recordTotal", "itemsPerPages", "currentPage", "onOnChangePage"])
    ])
  ]))
}